<template>
	<div class="w-100">
		<div class="w-100 mb-2 position-relative" style="height:150px;" @click="toggleDetail">
			<span v-if="is_decrease_promo" class="bg-green py-1 px-2 radius-12 body-3-1 position-absolute text-white" style="left:10px;top:10px;">-{{Math.floor(base_price.promotion_pct)}}%</span>
			<span v-if="is_variant || is_variant_notes" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;">
				<template v-if="is_variant">
					{{`${data.variant_list.length} ${$pluralWord(data.variant_list.length,'Variant')}`}}
				</template>
				<template v-else>
					{{ `${data.variant_notes.length} ${$pluralWord(data.variant_notes.length,'Variant')}` }}
				</template>
			</span>
			<img :src="data.image_url" class="img-fit radius-6" />
		</div>
		<div class="w-100 mb-2 no-ws" @click="toggleDetail">
			<p class="mb-0 body-2-1 text-truncate">{{data.name}}</p>
			<p 
				v-if="is_decrease_promo" 
				class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
				{{$formatCurrency(promotion_price)}}
			</p>
			<p 
				class="mb-0 body-2-1 text-orange"
				:class="{
					'd-inline-block align-middle': is_decrease_promo
				}"
				>
				{{$formatCurrency(final_price)}}
			</p>
		</div>
		<div class="w-100">
			<template v-if="qtyCart == 0">
				<button 
					v-if="is_valid_time.open && is_valid_time.close"
					class="ga-btn-primary-outline" 
					@click="changeQtyProduct('plus')"
					>
					Add to cart
				</button>
				<button 
					v-else
					@click="toggleTimeOrder()"
					class="g-btn g-btn-light g-btn-sm w-100" 
					>
					Not Yet Available
				</button>
			</template>
			<template v-else>
				<div class="w-100 position-relative text-right" v-if="!(is_variant || is_variant_notes)">
					<!-- <div class="d-table py-1 px-2 radius-6 border-semi-grey bg-grey-dark no-ws position-absolute" @click="toggleNote()" style="left:0;top:2px;">
						<img src="../../../../assets/img/icon/notes.svg" height="10" class="align-baseline"> 
						<span class="mb-0 body-3-1 ml-1">Note</span>
					</div> -->

					<div class="plus-min-set text-right">
            <img src="../../../../assets/img/icon/decrement.png" class="d-inline-block img-crement rounded-100" width="28"
              style="border:1px solid #70707046;" @click="changeQtyProduct('minus')">
            <p class="d-inline-block border-none text-center body-2-4 counter mb-0" style="width:35px;">{{qtyCart}}</p>
            <img src="../../../../assets/img/icon/increment.png" class="d-inline-block border-green img-crement rounded-100"
              width="28" @click="changeQtyProduct('plus')">
          </div>
				</div>
				<button 
					v-else
					@click="toggleVariant"
					class="ga-btn-primary" 
					>
					{{qtyCart}} {{$pluralWord(qtyCart,'Variant')}} Selected
				</button>
			</template>
		</div>

		<!-- DETAIL -->
		<popup-detail 
			:id_ref="data.id"
    	direction="bottom" 
    	:show="show_detail"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleDetail">
    	<template v-slot:body>
	    	<div class="py-3 px-3">
	        <div class="w-100 position-relative mb-3" style="height:270px;">
	        	<img :src="data.image_url" class="img-fit radius-12" />
	        	<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetail()">
							<img src="../../../../assets/img/icon/close.png" width="14" />
						</div>
						<span v-if="data.category != null" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;">{{data.category.name}}</span>
	        </div>
	        <div class="w-100">
	        	<div class="row">
	        		<div class="col-8 align-self-start">
	        			<div class="px-2">
	        				<p class="mb-0 heading-6-1">{{data.name}}</p>
	        				<template v-if="!is_variant">
			        			<p 
											v-if="is_decrease_promo" 
											class="mb-0 text-line-through body-2 d-inline-block align-middle mr-1">
											{{$formatCurrency(promotion_price)}}
										</p>
										<p 
											class="mb-0 body-1-2 text-orange mr-1"
											:class="{
												'd-inline-block align-middle': is_decrease_promo
											}"
											>
											{{$formatCurrency(final_price)}}
										</p>
										<span
											v-if="is_decrease_promo" 
											class="mb-0 font-bold text-green bg-green-light px-1 rounded-4 d-inline-block align-middle text-12">-{{Math.floor(base_price.promotion_pct)}}%</span>
									</template>
									<p class="body-2-2 mb-0" v-if="data.open_order_time != null && data.close_order_time != null">Available only : {{is_valid_time.open_time}} - {{is_valid_time.close_time}}</p>
	        			</div>
	        		</div>
	        		<!-- <div class="col-4 align-self-start">
	        			<div class="w-100 px-2 position-relative text-right" >
	        				<div class="d-inline-block align-middle cursor-pointer" @click="changeQtyProductDetail('minus')">
										<img src="../../../../assets/img/icon/svg-dec.svg" height="26">
									</div>
									<div class="d-inline-block align-middle px-2">
										<p class="mb-0 body-2-4 text-center">{{detail_qty}}</p>
									</div>
									<div class="d-inline-block align-middle cursor-pointer" @click="changeQtyProductDetail('plus')">
										<img src="../../../../assets/img/icon/svg-inc.svg" height="26">
									</div>
	        			</div>
	        		</div> -->
	        		<div class="col-12 mt-3" v-if="data.description != null">
	        			<p class="mb-0 px-2 body-2-2">{{data.description}}</p>
	        		</div>
	        		<div class="col-12 mt-3 mb-2">
	        			<div class="px-2">
			            <whatsappLink :name="data.name" :description="$t('hotel.concierge.fitur.ask-the-hotel-about-this-menu')" />
			          </div>
		          </div>
	        	</div>
	        </div>
	    	</div>
	    </template>
	    <template v-slot:footer>
	    	<div class="px-3 pt-3" v-if="!is_valid_time.open || !is_valid_time.close">
	    		<button 
						@click="toggleTimeOrder(true)"
						class="g-btn g-btn-light g-btn-lg w-100" 
						>
						Not Yet Available
					</button>
				</div>
				<template v-else>
					<div class="px-3 pt-3" v-if="qtyCart == 0 && !(is_variant || is_variant_notes)">
			    	<button
			    	 	@click="changeQtyProduct('plus')" 
							class="ga-btn-primary-lg" >
							Select Product
						</button>
					</div>
					<template v-else>
						<div class="px-3 pt-3" v-if="is_variant || is_variant_notes">
				    	<button
				    	 	@click="toggleVariant(true)" 
								class="ga-btn-primary-lg" >
								 <span v-if="qtyCart == 0">Select Product</span>
								 <span v-else>{{qtyCart}} Variant Selected</span>
							</button>
						</div>
						<div class="pt-2" v-else>
							<div class="row">
								<div class="col-4 offset-1 text-center">
									<p class="body-3-1 mb-1">Selected Product</p>
								</div>
							</div>
							<div class="row">
								<div class="col-4 offset-1 border border-dark py-2 radius-6">
									<div class="row no-gutters">
										<div class="col-4 align-self-center text-left">
											<div class="cursor-pointer" @click="changeQtyProduct('minus')">
												<img alt="minus-icon" src="../../../../assets/img/icon/minus-black.png" class="d-inline-block img-crement border border-dark rounded-100" width="28">
											</div>
										</div>
										<div class="col-4 align-self-center text-center">
											<p class="mb-0 sub-heading-1-2 text-center">{{qtyCart}}</p>
										</div>
										<div class="col-4 align-self-center text-right">
											<div class="cursor-pointer" @click="changeQtyProduct('plus')">
												<img alt="plus-icon" src="../../../../assets/img/icon/plus-black.png" class="d-inline-block border border-dark img-crement rounded-100" width="28">
											</div>
										</div>
									</div>
								</div>
								<div class="col-6">
									<state-button block variant="secondary" size="lg" :click="closePopupDetailAfterAdd">Save Change</state-button>
								</div>
							</div>
						</div>
					</template>
				</template>
	    </template>
    </popup-detail>

    <!-- NOTE -->
    <popup-detail 
			:id_ref="`${data.id}_note`"
    	direction="bottom" 
    	:show="show_note"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleNote">
    	<template v-slot:body>
    		<div class="w-100 border-semi-grey p-3 position-relative">
    			<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
						<img :src="data.image_url" class="img-fit radius-6">
					</div>
					<div class="d-inline-block align-middle w-75">
						<p class="mb-0 body-1-2">{{data.name}}</p>
						<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
						<p class="mb-0 body-2" v-if="variant_product_cart != null">{{variant_product_cart.name}}</p>
					</div>
					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleNote()">
						<img src="../../../../assets/img/icon/close.png" width="14" />
					</div>
    		</div>
    		<div class="py-3 px-3">
    			<p class="mb-1 body-1-1">Note :</p>
    			<div class="w-100 position-relative">
    				<input 
    					type="text" 
    					class="body-2-2 pl-5 pr-3 w-100 border-semi-grey radius-12" 
    					style="padding-top:12px;padding-bottom:12px;"
    					v-model="note">
    				<img src="../../../../assets/img/icon/notes.svg" height="14" class="position-absolute" style="left:20px;top:15px;">
    			</div>
    		</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
		    	<button 
		    		@click="saveNote()"
						class="ga-btn-primary-lg" >
						<pulse-loader :loading="push_loader_note" color="#fff" v-if="push_loader_note"></pulse-loader>
          	<template v-else>
            	Save Note
            </template>
					</button>
				</div>
	    </template>
    </popup-detail>

    <!-- VARIANTS -->
    <popup-detail 
			:id_ref="`${data.id}_variant`"
    	direction="bottom" 
    	:show="show_variant"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleVariant()">

    	<template v-slot:body>
    		<div class="w-100 border-bottom p-3 position-relative">
    			<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
						<img :alt="data.name" :src="data.image_url" class="img-fit radius-6">
					</div>
					<div class="d-inline-block align-middle w-75">
						<p class="mb-0 body-1-2">{{data.name}}</p>
						<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
						<template v-if="is_variant_notes">
							<p 
								v-if="is_decrease_promo" 
								class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
								{{$formatCurrency(promotion_price)}}
							</p>
							<p 
								class="mb-0 body-2-1 text-orange"
								:class="{
									'd-inline-block align-middle': is_decrease_promo
								}"
								>
								{{$formatCurrency(final_price)}}
							</p>
						</template>
					</div>
					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleVariant()">
						<img alt="close-icon" src="../../../../assets/img/icon/close.png" width="14" />
					</div>
    		</div>
    		<div class="p-3" :key="variant_detail_key">
    			<p class="body-3-1 mb-2">Variant List</p>
					<template v-if="is_variant">
						<template v-for="(variant,index) in data.variant_list">
							<menuItemVariant 
								@updateQty="updateVariantQty"
								:data="variant" 
								:product_cart_index="is_product_in_cart"></menuItemVariant>
						</template>
					</template>
					<template v-if="is_variant_notes">
						<template v-for="(variant,index) in data.variant_notes">
							<menuItemVariantNotes 
								@updateQty="updateVariantQty"
								:data="variant" 
								:product_cart_index="is_product_in_cart"></menuItemVariantNotes>
						</template>
					</template>
    		</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
		    	<state-button
		    	 	:click="saveVariantChange" 
						size="lg"
						variant="primary"
						block >
						Save Change
					</state-button>
				</div>
			</template>
    </popup-detail>

    <!-- TIME ORDER -->
    <popup-detail 
			:id_ref="`${data.id}_warning`"
    	direction="bottom" 
    	:show="show_time_order"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleTimeOrder">
    	<template v-slot:body>
    		<div class="py-5 px-4 text-center" v-if="data.open_order_time != null && data.close_order_time != null">
	    		<img-default />
	    		<p class="w-75 mt-4 mx-auto body-2-2">Sorry, <b>{{data.name }}</b> is only available from <b>{{is_valid_time.open_time}}</b> to <b>{{is_valid_time.close_time}}</b></p>
	    	</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
		    	<button 
		    		@click="toggleTimeOrder()"
						class="ga-btn-primary-lg" >
						Close
					</button>
				</div>
	    </template>
    </popup-detail>
	</div>
</template>
<script>
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
	import {mapGetters,mapMutations} from 'vuex';
  import whatsappLink from '@/components/hotel/concierge/general/whatsappLink';
  import moment from 'moment'
  import menuItemVariant from '@/components/hotel/concierge/general/MenuVariantFoodSquare'
  import menuItemVariantNotes from '@/components/hotel/concierge/general/MenuVariantNotesFoodSquare'

	export default{
		props: ['data'],
		components:{
			whatsappLink,
			menuItemVariant,
			menuItemVariantNotes
		},
		data(){
			return{
				show_detail: false,
				show_note: false,
				show_variant: false,
				show_time_order: false,
				variant_selected:{},
				variant_product_cart: null,
				detail_qty: 1,
				push_loader: false,
				push_loader_note: false,
				note: '',
				popup_stack: '',
				variant_update: [],
				variant_detail_key: 0,
				variant_notes_update: []
			}
		},
		computed:{
			...mapGetters(['getMerchant','getConciergeOrder','getMerchantTimezone']),
			is_variant(){
        return this.data.variant_list.length > 0 ? true : false
      },
			is_variant_notes(){
        return this.data.use_variant_notes
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? this.base_price.price_sell_base : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      is_product_in_cart(){
      	let record = this.getConciergeOrder.cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
      	return record
      },
      qtyCart(){
        let data = 0
        if(this.is_product_in_cart != -1){
          data = this.getConciergeOrder.cart[this.is_product_in_cart].qty
        }

        return data
      },
      is_valid_time(){
      	let return_data = {
      		open: false,
      		close: false,
      		open_time: "",
      		close_time: ""
      	}
    		let now_time = moment().toDate()
    		if(this.data.open_order_time != null){
    			let open_time_tz = moment(`${this.data.open_order_time}${this.getMerchantTimezone.offset}`,"HH:mm:ssZ").toDate()
    			let open_time_local = moment.parseZone(open_time_tz).local().toDate()    			
    			let open_time_valid = moment(open_time_local).isBefore(now_time)
    			return_data.open_time = moment(open_time_local).format('HH:mm')
    			return_data.open = open_time_valid
    		}else{
    			return_data.open = true
    		}
    		if(this.data.close_order_time != null){
    			let closed_time_tz = moment(`${this.data.close_order_time}${this.getMerchantTimezone.offset}`,"HH:mm:ssZ").toDate()
    			let closed_time_local = moment.parseZone(closed_time_tz).local().toDate()    			
    			let closed_time_valid = moment(closed_time_local).isAfter(now_time)
    			return_data.close_time = moment(closed_time_local).format('HH:mm')
    			return_data.close = closed_time_valid
    		}else{
    			return_data.close = true
    		}
      	return return_data
      }
		},
		watch:{
			show_detail(){
				if(this.show_detail){
					if(this.is_variant){
						this.variant_selected = this.data.variant_list[0]
					}else{
						this.detail_qty = this.qtyCart == 0 ? 1 : this.qtyCart	
						this.note = this.is_product_in_cart != -1 ? this.getConciergeOrder.cart[this.is_product_in_cart].notes : ''
					}
				}else{
					this.detail_qty = 1
					this.note = ''
				}
			},
			variant_selected:{
				deep: true,
				handler(){
					if(this.is_product_in_cart != -1){
						let record = this.getConciergeOrder.cart[this.is_product_in_cart].variant.findIndex(x=>x.data.id == this.variant_selected.id)
						if(record != -1){
							this.detail_qty = this.getConciergeOrder.cart[this.is_product_in_cart].variant[record].qty
							this.note = this.getConciergeOrder.cart[this.is_product_in_cart].variant[record].notes
						}else{
							this.detail_qty = 1
							this.note = ''
						}
					}else{
						this.detail_qty = 1
					}
				}
			},
			show_time_order(){
				if(this.show_time_order){
					this.checkIfProductCartWithTime()
				}
			}
		},
		mounted(){
			this.checkIfProductCartWithTime()
		},
		methods:{
			...mapMutations(['setConciergeOrder','removeConciergeOrder','setConciergeOrderNote','removeOneConciergeOrder']),
			toggleDetail(){
				this.show_detail = !this.show_detail
			},
			closePopupDetailAfterAdd(){
				return new Promise((success,fail)=>{
					setTimeout(() => {
						success()
						this.toggleDetail()
					}, 300);
				})
			},
			toggleNote(variant=null){
				this.show_note = !this.show_note
				if(this.show_note){
					if(variant != null){
						this.note = variant.notes
						this.variant_product_cart = variant.data
						this.toggleVariant()
					}else{
						this.variant_product_cart = null
						this.note = this.is_product_in_cart != -1 ? this.getConciergeOrder.cart[this.is_product_in_cart].notes : ''
					}
				}else{
					if(this.variant_product_cart != null){
						this.toggleVariant()
					}
					this.note = ''
				}
			},
			toggleVariant(from_detail=false){
				this.show_variant = !this.show_variant
				this.variant_detail_key++
				if(!this.show_variant){
					this.variant_update = []
				}else{
					if(this.is_product_in_cart != -1){
      			let variant_cart = this.getConciergeOrder.cart[this.is_product_in_cart].variant
						this.variant_update = variant_cart.map(el=>{
							delete el.notes
							return el
						})
      		}
				}
				let valid_form_detail = (typeof from_detail == 'boolean' && from_detail == true)
				if(valid_form_detail || this.popup_stack == 'detail'){
					this.popup_stack = valid_form_detail ? 'detail' : ''
					this.toggleDetail()
				}
			},
			toggleTimeOrder(from_detail=false){
				this.show_time_order = !this.show_time_order
				let valid_form_detail = (typeof from_detail == 'boolean' && from_detail == true)
				if(valid_form_detail || this.popup_stack == 'detail'){
					this.popup_stack = valid_form_detail ? 'detail' : ''
					this.toggleDetail()
				}
			},
			updateVariantQty(variant){

      	let variant_i = this.variant_update.findIndex(x=>this.is_variant ? x.data.product_ga_pos_id == variant.data.product_ga_pos_id : x.data == variant.data)
      	if(variant_i != -1){
      		if(variant.qty <= 0){
      			this.variant_update.splice(variant_i,1)
      		}else{
      			this.variant_update.splice(variant_i,1,variant)
      		}
      	}else{
      		this.variant_update.push(variant)
      	}
      },
      saveVariantChange(){
      	return new Promise((success,fail)=>{
      		if(this.product_cart_index == -1 && this.variant_update.length == 0){
      			setTimeout(()=>{
              this.toggleVariant()
      				success()
            },300)
      		}else{
      			let params = this.product_cart_index != -1 ? this.variant_update.length == 0 ? 'delete' : 'push_delete' : 'push'
      			this.updateVariantToVuex(params).then(()=>{
      				setTimeout(()=>{
	              this.toggleVariant()
	      				success()
	            },300)
      			})
      		}
      	})
      },
      updateVariantToVuex(action){
      	return new Promise((success,fail)=>{
	    		if(action == 'push'){
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setConciergeOrder(params)
		          if(index+1 == this.variant_update.length){
		          	success()
		          }
		      	})
	    		}else if(action == 'delete'){
	    			let variant_cart = this.$deepCopy(this.getConciergeOrder.cart[this.is_product_in_cart].variant)
	    			variant_cart.forEach((item,index)=>{
	    				let params = {
		            product: this.data,
		            variant: item.data
		          }
		          this.removeConciergeOrder(params)
		          if(this.is_product_in_cart == -1){
		          	success()
		          }
	    			})
	    		}else{
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setConciergeOrder(params)
		          if(index+1 == this.variant_update.length){
		          	let diff = this.getConciergeOrder.cart[this.is_product_in_cart].variant.filter(x=> !this.variant_update.some(y=>this.is_variant ? x.data.id == y.data.id : x.data == y.data))
		          	diff.forEach((item_diff,index_diff)=>{
		          		let params_diff = {
				            product: this.data,
				            variant: item_diff.data
				          }
				          this.removeConciergeOrder(params_diff)
				          if(index_diff+1 == diff.length){
				          	success()
				          }
		          	})
		          	if(diff.length == 0){
		          		success()
		          	}
		          }
		      	})
	    		}
      	})
      },
			calc_is_decrease_promo(price){
        if(price.promotion_amount == 0){
          return false
        }else{
        	return price.promotion_type == 'INCREASE' ? false : true
        }
      },  
      calc_finalPrice(price){
        return calculateFinalPriceConcierge(price)
      },
      calc_promotion_price(price){
        if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? (price.price_sell_base) : price.price_sell
        }
      },
      checkIfProductCartWithTime(){
      	if(this.is_product_in_cart != -1 && (!this.is_valid_time.open || !this.is_valid_time.close)){
					this.removeOneConciergeOrder(this.data.id)
				}
      },
      changeQtyProductDetail(type){
      	if(!this.push_loader){
	        if(type == 'minus'){
	        	let comparison = this.qtyCart == 0 ? 1 : 0

	          if(this.detail_qty > comparison){
	            this.detail_qty--
	          }
	        }else{
	          this.detail_qty++
	        }
      	}
      },
			changeQtyProduct(type){
        if(type == 'plus' && (this.is_variant || this.is_variant_notes)){
          this.toggleVariant()
        }else{
          let params = {
            product: this.data,
            variant: {},
            qty: this.qtyCart
          }
          if(this.qtyCart == 1 && type == 'minus'){
            this.removeConciergeOrder(params)
          }else{
            if(type == 'minus'){
              params.qty--
            }else{
              params.qty++
            }
            this.setConciergeOrder(params)
          }
        }
      },
      addToCartFromDetail(){
      	return new Promise((success,fail)=>{
	      	let data = {
	      		product: this.data,
	      		variant: this.is_variant ? this.variant_selected : {},
	      		qty: this.detail_qty
	      	}
	      	if(this.detail_qty == 0){
	      		this.removeConciergeOrder(data)
	      	}else{
	      		this.setConciergeOrder(data)
	      		this.saveNote(true)
	      	}
	      	setTimeout(()=>{
	      		this.toggleDetail()
	      		success()
	      	},300)
      	})
      },
      changeQtyProductCart(variant,type){
      	let params = {
      		product: this.data,
      		variant: variant.data,
      		qty: type == 'minus' ? variant.qty-1 : variant.qty+1
      	}

      	if(params.qty == 0){
      		this.removeConciergeOrder(params)
      		if(this.is_product_in_cart == -1){
      			this.toggleVariant()
      			document.body.style.overflow = 'auto'
      		}
      	}else{
      		this.setConciergeOrder(params)
      	}
      },
      saveNote(hide=false){
      	this.push_loader_note = true
        let params = {
          product_id: this.data.id,
          variant_id: this.variant_product_cart != null ? this.variant_product_cart.id : this.is_variant ? this.variant_selected.id : '',
          notes: this.note
        }
        this.setConciergeOrderNote(params)
        setTimeout(()=>{
      		this.push_loader_note = false
      		if(!hide){
      			this.toggleNote()
      		}
      	},1000)
      }
		}
	}
</script>
<style scoped>
	.dimention-24{
		width: 24px;
		height: 24px;
	}
	.variant-radio-active{
		border: 8px solid var(--merchant-primary-color) !important;
	}
	.img-crement {
    padding: 7px;
    border-radius: 5px;
  }
	@media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/MenuFoodSquare.vue